import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UnbalanceUnit } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { DateRange } from 'src/components';
import { US_BASE_URL } from './tokens';

export interface TileAssetInfo {
  /**
   * The id of the machine/plant/group that is selected.
   * Special case: ungrouped group has id '_ungrouped'.
   */
  selected?: string;
  /**
   * Time range in which to show statistics.
   */
  range: DateRange;
  unbalUnit?: UnbalanceUnit;
}

export interface TilePageInfo {
  /**
   * Info about the main asset and range to show statistics for.
   */
  main: TileAssetInfo;
  /**
   * Info about the compare asset and range to show statistics for.
   */
  compare?: TileAssetInfo;
  /**
   * After how many seconds to refresh the statistics.
   */
  interval: number;
  /**
   * Info about rotor type to show statistics for.
   */
  rotorType?: string;
  /**
   * In which unit the unbalance should be.
   */
  unbalUnit?: UnbalanceUnit;
}

export interface SettingsState {
  /**
   * How many decimal places the measurements should have.
   */
  decimals: number;
  /**
   * In which unit the measurements should be shown.
   */
  unbalUnit: UnbalanceUnit;
}

export const tilePagesSettingsKey = 'MC_TilePagesService_Settings';

@Injectable()
export class SettingsApi {
  private readonly baseUrl = inject(US_BASE_URL);
  protected http = inject(HttpClient);

  tilePageSettingsUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;

    this.tilePageSettingsUrl = baseUrl + '/v1/currentUser/machinecenter/tilepage';
  }

  loadTilePageSettings$(): Observable<TilePageInfo> {
    return this.http.get<any>(this.tilePageSettingsUrl);
  }

  setTilePageSettings$(tilePageInfo: TilePageInfo) {
    return this.http.put(this.tilePageSettingsUrl, tilePageInfo).subscribe();
  }
}
